import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const { login } = useAuth();

  return (
    <div className="container">
      <h1 className="text-center my-4">Login</h1>
      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card shadow-sm">
            <div className="card-body p-4">
              <p className="text-center mb-4">Bitte melden Sie sich an, um fortzufahren</p>
              <button
                onClick={login}
                className="btn btn-primary w-100 mb-3"
              >
                Mit Authentik anmelden
              </button>
              <hr />
              <p className="text-center mb-2">Noch kein Konto?</p>
              <Link
                to="/register"
                className="btn btn-outline-primary w-100"
              >
                Hier registrieren
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
